export default {"src":"/_next/static/media/0x367c17d19fcd0f7746764455497d63c8e8b2bba3.3bd8ca5a.svg","height":26,"width":26,"blurWidth":0,"blurHeight":0};